import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaRegSave, FaTimes } from 'react-icons/fa';

const AnamneseModal = ({ pessoa, anamnese: anamneseEspecifica, onClose, onAnamneseUpdated }) => {
	const [anamnese, setAnamnese] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [respostasAnamnese, setRespostasAnamnese] = useState([]);
	const [idFormularioCliente, setIdFormularioCliente] = useState(null);
	const [carregamentoInicial, setCarregamentoInicial] = useState(true);

	const formatarDataCriacao = (dataString) => {
		if (!dataString) return '';
		const data = new Date(dataString);
		return data.toLocaleString('pt-BR', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit'
		}).replace(',', '');
	};

	useEffect(() => {
		const fetchData = async () => {
			Swal.fire({
				title: "Carregando...",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showConfirmButton: false,
				didOpen: () => {
					Swal.showLoading();
				}
			});

			try {
				await getClientesAnamnese();
				if (pessoa?.e_cliente) {
					if (anamneseEspecifica) {
						await obterPerguntasRespostasAnamneseEspecifica();
					} else {
						setIdFormularioCliente(null);
						setRespostasAnamnese([]);
					}
				}
			} catch (error) {
				console.error('Erro ao carregar dados:', error);
			} finally {
				setCarregamentoInicial(false);
			}
		};
		fetchData();
	}, [pessoa, anamneseEspecifica]);

	const getClientesAnamnese = async () => {
		try {
			const response = await api.get(`/anamnese-formularios/1/perguntasrespostas`);
			setAnamnese(response.data.perguntasRespostas.records || []);
		} catch (err) {
			throw err;
		}
	};

	const obterPerguntasRespostasAnamneseEspecifica = async () => {
		if (!pessoa?.e_cliente || !anamneseEspecifica) return;

		try {
			setIdFormularioCliente(anamneseEspecifica.id);
			setRespostasAnamnese(anamneseEspecifica.json_respostas || []);
		} catch (err) {
			setIdFormularioCliente(null);
			setRespostasAnamnese([]);
		}
	};

	const renderInput = (pergunta) => {
		switch (pergunta.tp_pergunta) {
			case '01':
				return (
					<input type="text" className="form-control" autoComplete="off" id={`pergunta-${pergunta.id}`} />
				);
			case '02':
				return (
					<div>
						{pergunta.respostas.map((resposta) => (
							<div className="form-check" key={resposta.id}>
								<input className="form-check-input" type="checkbox" id={`pergunta-${pergunta.id}-resposta-${resposta.id}`} value={`${resposta.id}`} />
								<label className="form-check-label" htmlFor={`pergunta-${pergunta.id}-resposta-${resposta.id}`}>{resposta.ds_resposta}</label>
							</div>
						))}
					</div>
				);
			case '03':
				return (
					<div>
						{pergunta.respostas.map((resposta) => (
							<div className="form-check" key={resposta.id}>
								<input className="form-check-input" type="radio" name={`pergunta-${pergunta.id}`} id={`pergunta-${pergunta.id}-resposta-${resposta.id}`} value={`${resposta.id}`} />
								<label className="form-check-label" htmlFor={`pergunta-${pergunta.id}-resposta-${resposta.id}`}>{resposta.ds_resposta}</label>
							</div>
						))}
					</div>
				);
			case '04':
				return (
					<select className="form-control" id={`pergunta-${pergunta.id}`}>
						<option value="" hidden>Selecione...</option>
						{pergunta.respostas.map((resposta) => (
							<option key={resposta.id} value={resposta.id}>
								{resposta.ds_resposta}
							</option>
						))}
					</select>
				);
			case '05':
				return (
					<textarea className="form-control" id={`pergunta-${pergunta.id}`} rows="3" />
				);
			case '06':
				return (
					<div>
						<input type="file" className="form-control" id={`pergunta-${pergunta.id}`} />
						<a className="mt-2" id={`download-pergunta-${pergunta.id}`} style={{ display: 'none' }} href="#" target="_blank" rel="noopener noreferrer">Download</a>
					</div>
				);
			case '07':
				return (
					<div>
						<input type="range" className="form-control" id={`pergunta-${pergunta.id}`} min="0" max="10" />
						<div className="d-flex justify-content-between">
							<small>0</small>
							<small>10</small>
						</div>
					</div>
				);
			default:
				return null;
		}
	};

	const preencherCampos = async () => {
		if (!respostasAnamnese.length) return;

		for (const pergunta of respostasAnamnese) {
			const perguntaElement = document.querySelector(`[id^="pergunta-${pergunta.id}"]`);
			if (perguntaElement && pergunta.resposta) {
				switch (pergunta.tipo) {
					case "01": // Campo Texto
					case "05": // Campo Área de Texto
						perguntaElement.value = pergunta.resposta;
						break;

					case "02": // Campo Múltipla Escolha (checkbox)
					case "03": // Campo Escolha Única (radio)
						if (Array.isArray(pergunta.resposta)) {
							pergunta.resposta.forEach(resposta => {
								const checkbox = document.getElementById(`pergunta-${pergunta.id}-resposta-${resposta}`);
								if (checkbox) {
									checkbox.checked = true;
								}
							});
						}
						break;

					case "04": // Caixa de Seleção (select)
						if (Array.isArray(pergunta.resposta) && pergunta.resposta.length > 0) {
							perguntaElement.value = pergunta.resposta[0];
						}
						break;

					case "06": // Campo Arquivo
						try {
							const response = await api.get(`/arquivos/${pergunta.resposta}`);
							const byteArray = new Uint8Array(response.data.arquivo.data);
							const blob = new Blob([byteArray], { type: response.data.mimetype });

							const downloadLink = document.getElementById(`download-pergunta-${pergunta.id}`);
							downloadLink.innerText = 'Download - ' + response.data.nome;
							downloadLink.style.display = 'inline-block';

							const fileURL = URL.createObjectURL(blob);
							downloadLink.href = fileURL;
							downloadLink.download = response.data.nome;

							const file = new File([blob], response.data.nome, { type: blob.type });
							const dataTransfer = new DataTransfer();
							dataTransfer.items.add(file);
							perguntaElement.files = dataTransfer.files;
						} catch (error) {
							Swal.fire('Erro', 'Erro ao carregar arquivo.', 'error');
						}
						break;

					case "07": // Range
						perguntaElement.value = pergunta.resposta;
						break;
				}
			}
		}
	};

	const obterRespostasAnamnese = async () => {
		let respostas = [];
		for (const pergunta of anamnese) {
			const respostaObj = { id: pergunta.id, tipo: pergunta.tp_pergunta, pergunta: pergunta.ds_enunciado, resposta: null };
			const existeResposta = respostasAnamnese.find(x => x.id === pergunta.id);
			if (existeResposta) respostaObj.resposta = existeResposta.resposta;

			const perguntaElement = document.querySelector(`[id^="pergunta-${pergunta.id}"]`);

			if (perguntaElement) {
				switch (pergunta.tp_pergunta) {
					case "01": // Campo Texto
					case "05": // Campo Área de Texto
						respostaObj.resposta = perguntaElement.value || null;
						break;

					case "02": // Campo Múltipla Escolha (checkbox)
					case "03": // Campo Escolha Única (radio)
						const selecionados = document.querySelectorAll(`input[id^="pergunta-${pergunta.id}-"]:checked`);
						respostaObj.resposta = Array.from(selecionados).map((input) => input.value);
						break;

					case "04": // Caixa de Seleção (select)
						const selecionado = document.querySelectorAll(`select[id^="pergunta-${pergunta.id}"]`);
						respostaObj.resposta = Array.from(selecionado).map((input) => input.value);
						break;

					case "06": // Campo Arquivo
						const arquivo = perguntaElement.files?.[0];
						if (arquivo) {
							const formData = new FormData();
							formData.append('arquivo', arquivo, arquivo.name);
							try {
								const response = await api.post(`/arquivos`, formData);
								respostaObj.resposta = response.data.id;
							} catch (error) {
								Swal.fire('Erro', 'Erro ao fazer upload do arquivo.', 'error');
							}
						}
						break;

					case "07": // Range
						respostaObj.resposta = perguntaElement.value || null;
						break;
				}
			}
			respostas.push(respostaObj);
		}
		return respostas;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!pessoa?.e_cliente) {
			Swal.fire('Erro', 'Esta pessoa não é um cliente.', 'error');
			return;
		}

		setIsLoading(true);

		Swal.fire({
			title: "Carregando...",
			allowOutsideClick: false,
			allowEscapeKey: false,
			showConfirmButton: false,
			didOpen: () => {
				Swal.showLoading();
			}
		});

		try {
			const respostasAtualizadas = await obterRespostasAnamnese();

			const formularioCliente = {
				id_pessoa_cliente: pessoa.id,
				id_formulario: 1,
				json_respostas: respostasAtualizadas
			};

			if (idFormularioCliente) {
				await api.put(`/anamnese-cliente-formularios/${idFormularioCliente}`, formularioCliente);
			} else {
				await api.post(`/anamnese-cliente-formularios`, formularioCliente);
			}

			Swal.fire('Sucesso', 'Anamnese salva com sucesso!', 'success');
			if (onAnamneseUpdated) {
				onAnamneseUpdated();
			} else {
				onClose();
			}
		} catch (error) {
			Swal.close();
			Swal.fire('Erro', `${error.response.data.message || 'Erro ao salvar anamnese'}`, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const renderAnamneseGrid = () => {
		if (!anamnese.length) return null;

		const anamneseRows = anamnese.reduce((rows, pergunta, index) => {
			const rowIndex = Math.floor(index / 3);
			if (!rows[rowIndex]) {
				rows[rowIndex] = [];
			}
			rows[rowIndex].push(
				<div className="col-lg-4 col-12 mt-3" key={pergunta.id}>
					<label className="form-label fw-bold" htmlFor={`pergunta-${pergunta.id}`}>
						{pergunta.ds_enunciado}
					</label>
					{renderInput(pergunta)}
				</div>
			);
			return rows;
		}, []);

		return anamneseRows.map((row, index) => (
			<div className="row" key={index}>
				{row}
			</div>
		));
	};

	useEffect(() => {
		if (!carregamentoInicial) {
			if (anamnese.length > 0) {
				const timer = setTimeout(async () => {
					if (anamneseEspecifica && respostasAnamnese.length > 0) {
						await preencherCampos();
					}
					setTimeout(() => {
						Swal.close();
					}, 300);
				}, 200);
				return () => clearTimeout(timer);
			} else {
				const timer = setTimeout(() => {
					Swal.close();
				}, 300);
				return () => clearTimeout(timer);
			}
		}
	}, [carregamentoInicial, anamnese, respostasAnamnese, anamneseEspecifica]);

	return (
		<div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
			<div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div className="modal-content" onClick={(e) => e.stopPropagation()}>
					<div className="modal-header">
						<h4 className="fw-bold mt-2">
							{anamneseEspecifica ? `Anamnese - ${formatarDataCriacao(anamneseEspecifica.criado_em)}` : 'Nova Anamnese'}
						</h4>
						<button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
					</div>

					<div className="modal-body">
						{!pessoa?.e_cliente ? (
							<div className="alert alert-warning" role="alert">
								<strong>Atenção:</strong> Esta pessoa não é um cliente. A anamnese só pode ser preenchida para clientes.
							</div>
						) : carregamentoInicial ? (
							<div className="text-center">
								<div className="spinner-border text-primary" role="status">
									<span className="visually-hidden">Carregando...</span>
								</div>
							</div>
						) : (
							<>
								<div className="row mt-2 mb-2">
									<div className="col-12">
										<h6><strong>Cliente:</strong> {pessoa?.nome}</h6>
									</div>
								</div>

								<form onSubmit={handleSubmit}>
									{renderAnamneseGrid()}
								</form>
							</>
						)}
					</div>

					<div className="modal-footer mt-4">
						<div className="row">
							<div className="col-12 text-end">
								<button className="btn btn-outline-danger" type="button" onClick={onClose}>
									<FaTimes /> Fechar
								</button>
								{pessoa?.e_cliente && anamnese.length > 0 && (
									<button 
										className="btn btn-custom-primary ms-3" 
										type="submit" 
										disabled={isLoading} 
										onClick={handleSubmit}
									>
										<FaRegSave /> Salvar
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AnamneseModal; 